// extracted by mini-css-extract-plugin
export default {"cover":"cover_cover__gECgJ","cover_title":"cover_cover_title__zKvkB","cover_sub_title":"cover_cover_sub_title__Zn3il"};